const content: { [key: string]: string } = {
  pageTitle: "Emerald & Diamond LOS",
  timeoutError: "Due to the large group, this view may take some time to load. Please click the refresh button.",
  refresh: "Refresh",
};

export default content;
